import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

const formData = { id: 0, name: "", isPercentage: true, value: 0 };
const typeOptions = [
  { label: "Percentage", value: true },
  { label: "Fixed Amount (LKR)", value: false },
];

const SeasonalDiscountDialog = ({ discount, onCancel, onSubmit }) => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const toast = useRef(null);

  useEffect(() => {
    setForm(discount || { ...formData });
  }, [discount]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.name) newErrors.name = "Name is required";
    if (form.value === null || form.value === undefined || form.value < 0)
      newErrors.value = "Value is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const result = await axios.post("/api/seasonalDiscounts", form);
        if (result.data?.id) {
          toast.current.show({
            severity: "success",
            summary: "Discount Added/Updated",
            detail:
              "Seasonal discount has been successfully added/updated.",
            life: 3000,
          });
          setForm({ ...formData });
          onSubmit();
        }
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Discount Error",
          detail:
            "An error occurred while adding discount. Please try again.",
          life: 3000,
        });
      }
    }
  };

  return (
    <div>
      <Toast ref={toast} position="bottom-right" />
      <form onSubmit={handleSubmit}>
        <div className="p-field">
          <label htmlFor="name">Name *</label>
          <InputText
            id="name"
            name="name"
            value={form?.name || ""}
            onChange={handleChange}
            autoComplete="off"
          />
          {errors.name && <label className="p-error">{errors.name}</label>}
        </div>
        <div className="p-field">
          <label htmlFor="isPercentage">Type *</label>
          <Dropdown
            id="isPercentage"
            name="isPercentage"
            value={form?.isPercentage}
            options={typeOptions}
            onChange={handleChange}
            placeholder="Select Type"
          />
        </div>
        <div className="p-field">
          <label htmlFor="value">Value *</label>
          <InputNumber
            id="value"
            name="value"
            value={form?.value}
            onValueChange={(e) =>
              setForm((prev) => ({ ...prev, value: e.value }))
            }
            min={0}
          />
          {errors.value && <label className="p-error">{errors.value}</label>}
        </div>
        <div className="flex justify-content-end">
          <Button
            type="button"
            label="Cancel"
            className="p-button-text mr-2"
            onClick={onCancel}
          />
          <Button type="submit" label="Submit" />
        </div>
      </form>
    </div>
  );
};

export default SeasonalDiscountDialog;
